import { useMemo } from "react";

/**
 * Labels for spotlight shortcut keycaps derived from the runtime OS.
 * @agentic connections
 */
export type SpotlightKeyboardShortcutLabels = {
  readonly searchModifierLabel: string;
  readonly selectKeyLabel: string;
};

const defaultLabels: SpotlightKeyboardShortcutLabels = {
  searchModifierLabel: "Ctrl",
  selectKeyLabel: "Enter",
};

/**
 * Detects Apple vs non-Apple environments for patient spotlight shortcut copy.
 * @agentic connections
 */
const readSpotlightKeyboardShortcutLabels =
  (): SpotlightKeyboardShortcutLabels => {
    if (typeof navigator === "undefined") {
      return defaultLabels;
    }

    const platform = navigator.platform ?? "";
    const ua = navigator.userAgent ?? "";
    const isApple =
      /Mac|iPhone|iPod|iPad/i.test(platform) ||
      /Macintosh|Mac OS X|iPhone|iPad/i.test(ua);

    if (isApple) {
      return { searchModifierLabel: "⌘", selectKeyLabel: "Return" };
    }

    return defaultLabels;
  };

/**
 * Resolves OS-specific spotlight shortcut labels (defaults when `window` is unavailable).
 * @agentic connections
 */
export const useSpotlightKeyboardShortcutLabels =
  (): SpotlightKeyboardShortcutLabels =>
    useMemo(
      () =>
        typeof window === "undefined"
          ? defaultLabels
          : readSpotlightKeyboardShortcutLabels(),
      [],
    );
